import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import axios from 'axios';
import { TrendingCoins } from '../config/api';
import { CryptoState } from '../CryptoContext';
import AliceCarousel from 'react-alice-carousel';
import { Link } from 'react-router-dom';
const useStyles = makeStyles(()=> ({
      carousel: {
          height: "50%",
          display: "flex",
          alignItems: "center",

      },

      carouselItems: {
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          color: "white",
          cursor: "pointer",
          textTransform: "uppercase",
          fontFamily: "montserrat"
      },
}))

export function numberWithCommas (x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g,",")
}


const Carousel = () => {
   
    const classes= useStyles();
    const [trending, setTrending] = useState([])
    const { currency, symbol } = CryptoState();
    const fetchTrendingCoins = async ()=> {
        const { data } = await axios.get(TrendingCoins(currency))
        setTrending(data);
    }
    console.log(trending);
    useEffect(() => {
       
        fetchTrendingCoins();
    }, [currency]);

    const items = trending.map((coin)=> {
        let profit = coin.price_change_percentage_24h >=0;
           return(
          <Link className={classes.carouselItems} to={`/coins/${coin.id}`}>
            <img 
                src={coin?.image}
                alt={coin.name}
                height="80"
                style={{marginBottom: 10}}
            />
            <span>
                {coin?.symbol.toUpperCase()}
                &nbsp;
                <span 
                style={{
                    color: profit>0 ? "rgb(116, 242, 109)" : "red",
                    fontWeight: 500,
                }}
                >
                    {profit && "+"} {coin?.price_change_percentage_24h?.toFixed(2)}%
                </span>
            </span>
            <span>
        {symbol} {numberWithCommas(coin?.current_price.toFixed(2))}
            </span>
          </Link>

           );
    })


    const responsive = {
        0: {
            items: 2,
        },
        512: {
            items: 4,
        },
    };
    return (
        <>
        <div className={classes.carousel}>
            <AliceCarousel
            mouseTracking
            infinite
            autoPlayInterval={1000}
            animationDuration={1500}
            disableDotsControls
            responsive={responsive}
            autoPlay
            items={items}
            disableButtonsControls
             />
        </div>
        </>
    )
}

export default Carousel
